const marqueeItems = [
  "RESIDENTIAL SANCTUARY CARE",
  "HOTEL & HOUSEKEEPING",
  "YACHT DETAILING",
  "PRIVATE AVIATION VALET",
  "ECO-CONSCIOUS FORMULATIONS",
  "ON-TIME. EVERY TIME.",
  "SINT MAARTEN / ISLAND-WIDE",
];

export default function Marquee() {
  const items = [...marqueeItems, ...marqueeItems];
  return (
    <div className="editorial-ribbon" aria-label="Our service standard" data-testid="editorial-marquee">
      <div className="marquee-window">
        <div className="marquee-track">
          {items.map((item, index) => <span className="marquee-item" key={`${item}-${index}`}><i /> {item}</span>)}
        </div>
      </div>
    </div>
  );
}
